// src/services/supplierService.jsx
import axiosInstance from './axiosConfig';

const supplierService = {
  // Get all suppliers (optionally with pagination if backend supports it)
  getAll: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/suppliers?page=${page}&limit=${limit}`);
    // If backend returns { success, message, data: [...] }
    return Array.isArray(response.data)
      ? response.data
      : response.data.data;
  },

  getAllWithPagination: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/suppliers?page=${page}&limit=${limit}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/suppliers/${id}`);
    return response.data.data || response.data;
  },

 getActiveSuppliers: async () => {
  const response = await axiosInstance.get("/suppliers/active");
  return response.data.data.map(sup => ({
    value: sup.id,
    text: sup.name,
  }));
},

  // Single supplier creation
  create: async (data) => {
    const response = await axiosInstance.post('/suppliers/add', data);
    return response.data.data || response.data;
  },

  // Bulk supplier creation (if you ever need array input)
  createBulk: async (suppliersArray) => {
    const response = await axiosInstance.post('/suppliers/add', {
      suppliers: suppliersArray,
    });
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/suppliers/edit/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/suppliers/delete/${id}`);
    return response.data;
  },

  filter: async (filters = {}, page = 1, limit = 10) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (filters.search) params.append('search', filters.search);

    const response = await axiosInstance.get(`/suppliers?${params.toString()}`);
    return Array.isArray(response.data)
      ? response.data
      : response.data.data;
  },
};

export default supplierService;
